import ReactDOM from "react-dom";
import React from "react";
import GetHelp from "../components/get-help/GetHelp";

const init = () => {
  let mountPoint = document.querySelector("#GetHelp");
  // let pageType = document.body.getAttribute('data-type');

  if (mountPoint) {
    ReactDOM.render(<GetHelp />, mountPoint);
  }
};

// Init on initial page load
init();

